import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: () =>
      import("../views/Main.vue")
  },
  {
    path: "/Bombas",
    name: "Bombas",
    component: () =>
      import("../views/Bombas.vue")
  },
  {
    path: "/Valvulas",
    name: "Valvulas",
    component: () =>
      import("../views/Valvulas.vue")
  },
  {
    path: "/admin",
    name: "Login",
    component: () =>
      import("../views/Login.vue")
  },
  {
    path: "/tabela",
    name: "Tabela",
    component: () =>
      import("../views/Tabela.vue"),
    meta: {
      requiresAuth: true,
    },
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token');
    if (!token) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});


export default router;
